export default __webpack_public_path__ + "images/security_740935.svg";